import { type AxiosPromise } from "axios";
import React from "react";
import RelatedFiles from "../../../components/RelatedFiles/RelatedFiles";
import { type FileTypes } from "../../../utilities/fileutils";

interface Props {
  onFilesSelected: (files: server.dto.File[]) => void
  fetchRelatedFiles: () => AxiosPromise<server.dto.RelatedFiles>
  fileSizeLimit: number
  validFileTypes: FileTypes
}

const FromStorage = (props: Props) => {
  const [relatedFiles, setRelatedFiles] = React.useState<server.dto.RelatedFiles>(undefined);

  return <RelatedFiles
    onFilesSelected={props.onFilesSelected}
    initialSelectedFiles={[]}
    onRelatedFilesChanged={setRelatedFiles}
    relatedFiles={relatedFiles}
    relatedFilesApi={props.fetchRelatedFiles}
    maxFileSize={props.fileSizeLimit}
    validFileTypes={props.validFileTypes}
  />;
};

export default FromStorage;